import { LocalStorageKey } from '../../../constants/localStorageKeys';
import {
	ChatPanelDefaultWidth,
	clampChatPanelWidth,
	MaxStoredMessages,
} from './chatConfig';

const emptyConversation = { conversationId: null, messages: [] };

// Kept with its conversationId, so a reload continues the same conversation
// rather than silently starting a new one.
export const readConversation = () => {
	try {
		const stored = localStorage.getItem(LocalStorageKey.chatConversation);
		if (!stored) {
			return emptyConversation;
		}
		const parsed = JSON.parse(stored);
		return {
			conversationId: parsed?.conversationId || null,
			messages: Array.isArray(parsed?.messages) ? parsed.messages : [],
		};
	} catch (e) {
		return emptyConversation;
	}
};

export const writeConversation = ({ conversationId, messages }) => {
	try {
		localStorage.setItem(
			LocalStorageKey.chatConversation,
			JSON.stringify({
				conversationId: conversationId,
				messages: messages.slice(-MaxStoredMessages),
			})
		);
	} catch (e) {
		// A full or unavailable quota must not break the chat.
	}
};

export const clearConversation = () => {
	localStorage.removeItem(LocalStorageKey.chatConversation);
};

// Re-clamped on read: the width may have been saved on a much wider screen.
export const readPanel = () => {
	try {
		const stored = localStorage.getItem(LocalStorageKey.chatPanel);
		const parsed = stored ? JSON.parse(stored) : null;
		return {
			isOpen: parsed?.isOpen === true,
			width: clampChatPanelWidth(
				Number(parsed?.width) || ChatPanelDefaultWidth
			),
		};
	} catch (e) {
		return { isOpen: false, width: clampChatPanelWidth(ChatPanelDefaultWidth) };
	}
};

export const writePanel = ({ isOpen, width }) => {
	try {
		localStorage.setItem(
			LocalStorageKey.chatPanel,
			JSON.stringify({ isOpen: isOpen === true, width: width })
		);
	} catch (e) {
		// Storage being unavailable only costs the remembered layout.
	}
};
